import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { rememberPendingPath } from '../utils/pendingPath'

interface ProtectedRouteProps {
  children: React.ReactElement
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { initAuth, isAuthenticated } = useAuthStore()
  const location = useLocation()
  const [hasInitialized, setHasInitialized] = useState(false)

  useEffect(() => {
    initAuth()
    setHasInitialized(true)
  }, [initAuth])

  // 인증 상태 초기화 전에는 대기
  if (!hasInitialized) {
    return null
  }

  if (!isAuthenticated) {
    /*
     * 어디로 가려던 건지 적어 둔다.
     *
     * 이게 없으면 로그인 뒤 홈으로 떨어지고 하려던 일이 사라진다. 인스타에서
     * 공유로 들어온 사람에게 특히 나쁘다 — 링크를 들고 왔는데 로그인하고 나면
     * 그 링크가 없어진다. 처음 쓰는 사람이 바로 그 경로로 들어온다.
     *
     * state 가 아니라 저장소에 적는 이유: 소셜 로그인은 카카오·네이버 쪽으로
     * 나갔다 돌아오면서 화면 상태가 날아간다.
     */
    rememberPendingPath(location.pathname + location.search)

    return <Navigate to="/login" replace />
  }

  return children
}

export default ProtectedRoute
